//----- Component --------------------------------------------------------/

// Developer :  Nicolas Pascucci

// Creation Date : 11/02/2025

// Version : 1

// Description : Edición de datos de un empleado

//

//------Changes --------------------------------------------------------------------- -------------//

// Change Date :

// Change by :

// Change description:

//

// Change Date :

// Change by :

// Change description:

//
//========================================================================/
import React, { useEffect, useState } from "react";
import Notify from "../../Notify";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { getData, postData, putData } from "../../../services/library";

function EditarEmpleado(props) {
  const [datosEmpleado, setDatosEmpleado] = useState(props.row);
  console.log(datosEmpleado);
    const empresas = [
        { idempresa: 2, empresa: "Italgas" },
        { idempresa: 4, empresa: "Natural Gas" },
  ]
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [disabled, setDisabled] = useState(false);
  const [tallesPantalon, setTallesPantalon] = useState();
  const [tallesRemera, setTallesRemera] = useState();
  const [tallesBuzo, setTallesBuzo] = useState();
  const [tallesBotin, setTallesBotin] = useState();
  const [tallesFaja, setTallesFaja] = useState();
  const [tallesCampera, setTallesCampera] = useState();
  const [sucursales, setSucursales] = useState();
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");
  const [legajoEncontrado, setLegajoEncontrado] = useState();
  const [colorError, setColorError] = useState();
  const [isLegajoModified, setIsLegajoModified] = useState(false);
  const [originalLegajo, setOriginalLegajo] = useState(props.row.nro_legajo);
    const [puestos, setPuestos] = useState()
    const [puestoSeleccionado, setPuestoSeleccionado] = useState("")

  const obtenerTallesPantalon = () => {
    getData("/stock_prendas_talles/tallesxprendaactivo/" + 2, setTallesPantalon);
  };
  const obtenerTallesRemera = () => {
    getData("/stock_prendas_talles/tallesxprendaactivo/" + 1, setTallesRemera);
  };
  const obtenerTallesBuzo = () => {
    getData("/stock_prendas_talles/tallesxprendaactivo/" + 5, setTallesBuzo);
  };
  const obtenerTallesBotin = () => {
    getData("/stock_prendas_talles/tallesxprendaactivo/" + 3, setTallesBotin);
  };
  const obtenerTallesFaja = () => {
    getData("/stock_prendas_talles/tallesxprendaactivo/" + 4, setTallesFaja);
  };
  const obtenerTallesCampera = () => {
    getData("/stock_prendas_talles/tallesxprendaactivo/" + 6, setTallesCampera);
  };
  const obtenerSucursales = () => {
    getData("/sucursales", setSucursales);
  };
    const obtenerPuestos = () => {
      getData("/SP_puestos/", setPuestos);
    };

  useEffect(() => {
    obtenerTallesPantalon();
    obtenerTallesRemera();
    obtenerTallesBuzo();
    obtenerTallesBotin();
    obtenerTallesFaja();
    obtenerTallesCampera();
    obtenerSucursales();
    obtenerPuestos();
  }, []);
  const almacenar = (e) => {
    const { name, value } = e.target;
    setDatosEmpleado({
      ...datosEmpleado,
      [name]: value,
    });

    // Marcar que el campo nro_legajo ha sido modificado
    if (name === "nro_legajo") {
      setIsLegajoModified(true);
    }
  };

  const guardarEditar = (e) => {
    setDisabled(true);
    putData(
      e,
      "/stock_empleados/"+ datosEmpleado.id,
      {
        nro_legajo: datosEmpleado.nro_legajo,
        sucursal: sucursalSeleccionada.id,
        nombre: datosEmpleado.nombre,
        apellido: datosEmpleado.apellido,
        dni: datosEmpleado.dni,
        pantalon: datosEmpleado.pantalon,
        remera: datosEmpleado.remera,
        buzo: datosEmpleado.buzo,
        botin: datosEmpleado.botin,
        faja: datosEmpleado.faja,
        campera: datosEmpleado.campera,
        puesto: puestoSeleccionado.id,
        empresa:datosEmpleado.empresa
      },
      setNotificacion
    );
  };

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };
  // console.log(datosEmpleado,sucursalSeleccionada);
  

  useEffect(() => {
    if (datosEmpleado.sucursal !== "" && sucursales) {
      const sucursalEncontrada = sucursales.find(
        (d) => d.id === datosEmpleado.sucursal
      );
      if (sucursalEncontrada) {
        setSucursalSeleccionada(sucursalEncontrada);
      }
    }
    

  }, [sucursales]);
    useEffect(() => {
    if (datosEmpleado.puesto !== "" && puestos) {
      const puestoEncontrado = puestos.find(
        (d) => d.id === datosEmpleado.puesto
      );
      if (puestoEncontrado) {
        setPuestoSeleccionado(puestoEncontrado);
      }
    }
    

  }, [puestos]);


  // Verifica si el legajo está repetido solo si el campo ha sido modificado
  useEffect(() => {
    if (isLegajoModified && datosEmpleado.nro_legajo !== "" && props.empleados) {
      // Si el legajo actual es igual al original, permitir guardar
      if (datosEmpleado.nro_legajo === originalLegajo) {
        setLegajoEncontrado();
        setColorError("primary");
        setDisabled(false);
      } else {
        // Si el legajo es diferente, verificar si está repetido
        const legajoEncontrado = props.empleados.find(
          (e) => e.nro_legajo === datosEmpleado.nro_legajo
        );
        if (legajoEncontrado) {
          setLegajoEncontrado(legajoEncontrado);
          setColorError("error");
          setDisabled(true);
        } else {
          setLegajoEncontrado();
          setColorError("primary");
          setDisabled(false);
        }
      }
    }
  }, [datosEmpleado.nro_legajo, isLegajoModified, originalLegajo]);

  return (
    <div>
      {notificacion && notificacion.open ? (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={() => {
            props.setOpen(false);
          }}
          severity={notificacion.severity}
        />
      ) : null}
      <Dialog
        fullWidth
        open={props.open}
        onClose={() => props.setOpen(false)}
        maxWidth="lg"
        // position="absolute"
        // sx={{ zIndex: "1000" }}
      >
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography variant="h6" align="center" color="#ffffff">
              Editar Empleado {datosEmpleado.nombre} {datosEmpleado.apellido}
            </Typography>
          </DialogTitle>
        </Box>
        <form onSubmit={guardarEditar}>
          <Box
            border={0.5}
            borderColor={grey[300]}
            backgroundColor="#F4F6F6"
            p={2}
            py={2}
            mt={1}
          >
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={2}>
                  <TextField
                    label="N° Legajo"
                    size="small"
                    name="nro_legajo"
                    value={datosEmpleado.nro_legajo}
                    onChange={almacenar}
                    focused
                    fullWidth
                    required
                    style={style}
                    color={colorError}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    label="Nombre"
                    size="small"
                    name="nombre"
                    value={datosEmpleado.nombre}
                    onChange={almacenar}
                    focused
                    style={style}
                    required
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    label="Apellido"
                    size="small"
                    name="apellido"
                    value={datosEmpleado.apellido}
                    onChange={almacenar}
                    focused
                    required
                    style={style}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    label="DNI"
                    size="small"
                    name="dni"
                    value={datosEmpleado.dni}
                    onChange={almacenar}
                    focused
                    style={style}
                    // required
                  />
                </Grid>
                <Grid item xs={6}>
                  <Autocomplete
                    disabled={!puestos}
                    size="small"
                    focused
                    disableClearable
                    id="puesto"
                    noOptionsText={"Puesto INEXISTENTE"}
                    options={puestos || null}
                    autoHighlight
                    getOptionLabel={(puesto) =>
                      puesto.puesto
                    }
                    onChange={(event, value) => setPuestoSeleccionado(value)}
                    value={puestoSeleccionado || null}
                    defaultValue={puestoSeleccionado || null}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.puesto}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        focused
                        required
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Puesto"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Autocomplete
                    disabled={!sucursales}
                    size="small"
                    focused
                    disableClearable
                    id="sucursal"
                    noOptionsText={"Sucursal INEXISTENTE"}
                    options={sucursales || null}
                    autoHighlight
                    getOptionLabel={(sucursal) =>
                      sucursal.id + "-" + sucursal.nombre
                    }
                    onChange={(event, value) => setSucursalSeleccionada(value)}
                    value={sucursalSeleccionada || null}
                    defaultValue={sucursalSeleccionada || null}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.id} - {option.nombre}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        focused
                        required
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Sucursal"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <FormControl style={style} focused>
                    <InputLabel>Empresa</InputLabel>
                    <Select
                      label="Empresa"
                      size="small"
                      name="empresa"
                      value={datosEmpleado.empresa}
                      onChange={almacenar}
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                    >
                      {empresas
                        ? empresas.map((elemento) => (
                            <MenuItem key={elemento.idempresa} value={elemento.idempresa}>
                              {elemento.empresa}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <FormControl style={style} focused>
                    <InputLabel>Talle Pantalon</InputLabel>
                    <Select
                      label="Talle Pantalon"
                      size="small"
                      name="pantalon"
                      value={datosEmpleado.pantalon}
                      onChange={almacenar}
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                    >
                      <MenuItem value={null}>
                        <em>No</em>
                      </MenuItem>
                      {tallesPantalon
                        ? tallesPantalon.map((elemento) => (
                            <MenuItem key={elemento.id} value={elemento.id}>
                              {elemento.talle}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <FormControl style={style} focused>
                    <InputLabel>Talle Remera</InputLabel>
                    <Select
                      label="Talle Remera"
                      size="small"
                      name="remera"
                      value={datosEmpleado.remera}
                      onChange={almacenar}
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                    >
                      <MenuItem value={null}>
                        <em>No</em>
                      </MenuItem>
                      {tallesRemera
                        ? tallesRemera.map((elemento) => (
                            <MenuItem key={elemento.id} value={elemento.id}>
                              {elemento.talle}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <FormControl style={style} focused>
                    <InputLabel>Talle Buzo</InputLabel>
                    <Select
                      label="Talle Buzo"
                      size="small"
                      name="buzo"
                      value={datosEmpleado.buzo}
                      onChange={almacenar}
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                    >
                      <MenuItem value={null}>
                        <em>No</em>
                      </MenuItem>
                      {tallesBuzo
                        ? tallesBuzo.map((elemento) => (
                            <MenuItem key={elemento.id} value={elemento.id}>
                              {elemento.talle}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <FormControl style={style} focused>
                    <InputLabel>Talle Botin</InputLabel>
                    <Select
                      label="Talle Botin"
                      size="small"
                      name="botin"
                      value={datosEmpleado.botin}
                      onChange={almacenar}
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                    >
                      <MenuItem value={null}>
                        <em>No</em>
                      </MenuItem>
                      {tallesBotin
                        ? tallesBotin.map((elemento) => (
                            <MenuItem key={elemento.id} value={elemento.id}>
                              {elemento.talle}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <FormControl style={style} focused>
                    <InputLabel>Talle Faja</InputLabel>
                    <Select
                      label="Talle faja"
                      size="small"
                      name="faja"
                      value={datosEmpleado.faja}
                      onChange={almacenar}
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                    >
                      <MenuItem value={null}>
                        <em>No</em>
                      </MenuItem>
                      {tallesFaja
                        ? tallesFaja.map((elemento) => (
                            <MenuItem key={elemento.id} value={elemento.id}>
                              {elemento.talle}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <FormControl style={style} focused>
                    <InputLabel>Talle Campera</InputLabel>
                    <Select
                      label="Talle Campera"
                      size="small"
                      name="campera"
                      value={datosEmpleado.campera}
                      onChange={almacenar}
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                    >
                      <MenuItem value={null}>
                        <em>No</em>
                      </MenuItem>
                      {tallesCampera
                        ? tallesCampera.map((elemento) => (
                            <MenuItem key={elemento.id} value={elemento.id}>
                              {elemento.talle}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid
                mt={1}
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Button
                  // disabled={disBtn}
                  variant="contained"
                  onClick={() => props.setOpen(false)}
                  color="error"
                >
                  Volver
                </Button>
                <Button
                  disabled={disabled}
                  variant="contained"
                  // onClick={guardarEmpleados}
                  type="submit"
                  color="success"
                >
                  Guardar
                </Button>
              </Grid>
            </DialogContent>
          </Box>
        </form>
      </Dialog>
    </div>
  );
}

export default EditarEmpleado;
